import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import Header from './Components/Header';
import Home from './Components/Home';
import AboutUs from './Components/AboutUs';
// import SocialIcons from './Components/SocialIcons';
import Events from './Components/Events';
// import Corporate from './Components/Corporate';
// import Careers from './Components/Careers';
import Gallery from './Components/GallerySection';
// import BlogPosts from './Components/BlogPosts';
import ContactUS from './Components/ContactUS';
import Venue from './Components/Venue';
import LibraBanquetHall from './Components/LibraBanquetHall';
import EvaBanquetHall from './Components/EvaBanquetHall';
import MarigoldBanquetHall from './Components/MarigoldBanquetHall';
// import './Css/styles.css';
import './App.css';
import Loder from './Components/Loder'; // Loader component
// import CustomCursor from './Components/CustomCursor';
import PageTitle from './Components/PageTitle';
import Lilac from './Components/Lilac';
import Lily from './Components/Lily'
import Lotus from './Components/Lotus'

import BlogList from './Components/BlogList';
import BlogPost from './Components/BlogPost';

import EvaBanquet from './Components/EvaBanquet';
import ScrollToTop from "./Components/ScrollToTop";

// Component to wrap routes and conditionally show loader
const AppRoutes = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(location.pathname === '/');
 
  useEffect(() => {
    if (location.pathname === '/') {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 2500);
      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [location.pathname]);
 
  if (loading) return <Loder />;
 
  return (
    <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/events" element={<Events />} />
            <Route path="/ContactUS" element={<ContactUS />} />
            <Route path="/venues" element={<Venue />} />
            <Route path="/LibraBanquetHall" element={<LibraBanquetHall />} />
            <Route path="/EvaBanquetHall" element={<EvaBanquetHall />} />
            <Route path="/KBPatelPARTYPLOT" element={<MarigoldBanquetHall />} />
            <Route path="/Lilac" element={<Lilac />} />
            <Route path="/Lily" element={<Lily />} />
            <Route path="/Lotus" element={<Lotus />} />
            <Route path="/EvaBanquet" element={<EvaBanquet />} />

            {/* Main blog page route */}
          <Route path="/blog" element={<BlogList />} />
          {/* Dynamic route for individual blog posts */}
          <Route path="/blog/:slug" element={<BlogPost />} />
    </Routes>
  );
};
 
function App() {
  return (
    <Router>
      <ScrollToTop />
      {/* <CustomCursor /> */}
      <AppRoutes />
      <PageTitle />
    </Router>
  );
}
 
export default App;